module.exports = __webpack_public_path__ + "static/img/2.644e293.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/2.png
// module id = /YBf
// module chunks = 0